import * as React from 'react';

const SvgCall = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M25.785 34.883 21.468 39.2c-.91.91-2.357.91-3.29.023-.257-.256-.513-.49-.77-.746a66.28 66.28 0 0 1-6.51-7.63c-1.913-2.66-3.453-5.32-4.573-7.957-1.097-2.66-1.657-5.203-1.657-7.63 0-1.587.28-3.103.84-4.503.56-1.424 1.447-2.73 2.683-3.897 1.494-1.47 3.127-2.193 4.854-2.193.653 0 1.306.14 1.89.42.606.28 1.143.7 1.563 1.306l5.413 7.63c.42.584.724 1.12.934 1.634.21.49.326.98.326 1.423 0 .56-.163 1.12-.49 1.657-.303.536-.746 1.096-1.306 1.656L19.6 22.237c-.256.256-.373.56-.373.933 0 .187.023.35.07.537.07.186.14.326.187.466.42.77 1.143 1.774 2.17 2.987a79.758 79.758 0 0 0 3.383 3.687c.233.233.49.466.723.7.934.91.957 2.403.024 3.336ZM51.262 42.77c0 .653-.117 1.33-.35 1.983-.07.187-.14.374-.234.56a9.626 9.626 0 0 1-1.586 2.38c-1.144 1.26-2.404 2.17-3.827 2.754-.023 0-.047.023-.07.023-1.377.56-2.87.863-4.48.863-2.38 0-4.923-.56-7.607-1.703-2.683-1.143-5.366-2.683-8.026-4.62-.91-.677-1.82-1.353-2.684-2.077l7.63-7.63c.654.49 1.237.864 1.727 1.12.117.047.257.117.42.187.187.07.373.093.583.093.397 0 .7-.14.957-.396l1.773-1.75c.584-.584 1.144-1.027 1.68-1.307.537-.327 1.074-.49 1.657-.49.443 0 .91.093 1.423.303.514.21 1.05.514 1.634.91l7.723 5.484c.607.42 1.027.91 1.283 1.493.234.583.374 1.167.374 1.82Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgCall;
